import createIcon from '../../createIcon';

/**
 * @component @name BroadcastOnHome
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEuMjUgNUMyMS4yNSAzLjkgMjAuMzUgMyAxOS4yNSAzSDMuMjVWNUgxOS4yNVY3LjU5QzE5Ljk4IDcuODggMjAuNjUgOC4yOCAyMS4yNSA4Ljc2VjVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNNy4yNSA4SDIuMjVDMS43NSA4IDEuMjUgOC41IDEuMjUgOVYxOEMxLjI1IDE4LjUgMS43NSAxOSAyLjI1IDE5SDcuMjVDNy43NSAxOSA4LjI1IDE4LjUgOC4yNSAxOFY5QzguMjUgOC41IDcuNzUgOCA3LjI1IDhaTTYuMjUgMTdIMy4yNVYxMEg2LjI1VjE3WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE3IDE1Ljk3QzE3LjMgMTUuNzQgMTcuNSAxNS40IDE3LjUgMTVDMTcuNSAxNC4zMSAxNi45NCAxMy43NSAxNi4yNSAxMy43NUMxNS41NiAxMy43NSAxNSAxNC4zMSAxNSAxNUMxNSAxNS40IDE1LjIgMTUuNzUgMTUuNSAxNS45N1YyMUgxN1YxNS45N1oiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNi4yNSAxMi41QzE3LjYzIDEyLjUgMTguNzUgMTMuNjIgMTguNzUgMTVDMTguNzUgMTUuNjkgMTguNDcgMTYuMzEgMTguMDIgMTYuNzZMMTkuMDggMTcuODJDMTkuOCAxNy4xIDIwLjI1IDE2LjEgMjAuMjUgMTVDMjAuMjUgMTIuNzkgMTguNDYgMTEgMTYuMjUgMTFDMTQuMDQgMTEgMTIuMjUgMTIuNzkgMTIuMjUgMTVDMTIuMjUgMTYuMSAxMi43IDE3LjEgMTMuNDIgMTcuODNMMTQuNDggMTYuNzdDMTQuMDMgMTYuMzIgMTMuNzUgMTUuNjkgMTMuNzUgMTVDMTMuNzUgMTMuNjIgMTQuODcgMTIuNSAxNi4yNSAxMi41WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE2LjI1IDguNUMxMi42NiA4LjUgOS43NSAxMS40MSA5Ljc1IDE1QzkuNzUgMTYuNzkgMTAuNDggMTguNDIgMTEuNjUgMTkuNkwxMi43MSAxOC41NEMxMS44MSAxNy42MyAxMS4yNSAxNi4zOCAxMS4yNSAxNUMxMS4yNSAxMi4yNCAxMy40OSAxMCAxNi4yNSAxMEMxOS4wMSAxMCAyMS4yNSAxMi4yNCAyMS4yNSAxNUMyMS4yNSAxNi4zNyAyMC42OSAxNy42MiAxOS43OSAxOC41MkwyMC44NiAxOS41OEMyMi4wMyAxOC40IDIyLjc1IDE2Ljc4IDIyLjc1IDE1QzIyLjc1IDExLjQxIDE5Ljg0IDguNSAxNi4yNSA4LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BroadcastOnHome = createIcon('BroadcastOnHome', [
  [
    'path',
    {
      d: 'M21.25 5C21.25 3.9 20.35 3 19.25 3H3.25V5H19.25V7.59C19.98 7.88 20.65 8.28 21.25 8.76V5Z',
      key: 'u8fw4h',
    },
  ],
  [
    'path',
    {
      d: 'M7.25 8H2.25C1.75 8 1.25 8.5 1.25 9V18C1.25 18.5 1.75 19 2.25 19H7.25C7.75 19 8.25 18.5 8.25 18V9C8.25 8.5 7.75 8 7.25 8ZM6.25 17H3.25V10H6.25V17Z',
      key: 'kslz4w',
    },
  ],
  [
    'path',
    {
      d: 'M17 15.97C17.3 15.74 17.5 15.4 17.5 15C17.5 14.31 16.94 13.75 16.25 13.75C15.56 13.75 15 14.31 15 15C15 15.4 15.2 15.75 15.5 15.97V21H17V15.97Z',
      key: '1ukxd5',
    },
  ],
  [
    'path',
    {
      d: 'M16.25 12.5C17.63 12.5 18.75 13.62 18.75 15C18.75 15.69 18.47 16.31 18.02 16.76L19.08 17.82C19.8 17.1 20.25 16.1 20.25 15C20.25 12.79 18.46 11 16.25 11C14.04 11 12.25 12.79 12.25 15C12.25 16.1 12.7 17.1 13.42 17.83L14.48 16.77C14.03 16.32 13.75 15.69 13.75 15C13.75 13.62 14.87 12.5 16.25 12.5Z',
      key: 'y9wwbd',
    },
  ],
  [
    'path',
    {
      d: 'M16.25 8.5C12.66 8.5 9.75 11.41 9.75 15C9.75 16.79 10.48 18.42 11.65 19.6L12.71 18.54C11.81 17.63 11.25 16.38 11.25 15C11.25 12.24 13.49 10 16.25 10C19.01 10 21.25 12.24 21.25 15C21.25 16.37 20.69 17.62 19.79 18.52L20.86 19.58C22.03 18.4 22.75 16.78 22.75 15C22.75 11.41 19.84 8.5 16.25 8.5Z',
      key: '19hab2',
    },
  ],
]);

export default BroadcastOnHome;
